module.exports = __webpack_public_path__ + "static/media/divideSvg.0714aa8e.svg";